type IconProps = { className?: string };

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function CashIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <rect x="2.5" y="6" width="19" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.6" />
    </svg>
  );
}

export function CloseIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12.4l2.6 2.6L16 9.4" />
    </svg>
  );
}

export function PnLIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24">
      <rect x="4" y="13" width="3" height="7" rx="0.6" fill="currentColor" />
      <rect x="10.5" y="8" width="3" height="12" rx="0.6" fill="currentColor" />
      <rect x="17" y="4" width="3" height="16" rx="0.6" fill="currentColor" />
    </svg>
  );
}

export function BuyIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.2a2 2 0 0 0 2-1.6L20 8H6.5" />
      <circle cx="10" cy="20" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="17" cy="20" r="1.3" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function StockIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <rect x="3.3" y="10.2" width="6.6" height="6.6" rx="0.8" />
      <rect x="14.1" y="10.2" width="6.6" height="6.6" rx="0.8" />
      <rect x="8.7" y="3.6" width="6.6" height="6.6" rx="0.8" />
    </svg>
  );
}

export function SellIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <path d="M3 17l6-6 4 4 8-9" />
      <path d="M15 6h6v6" />
    </svg>
  );
}

export function MaintainIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2-2 2.6-2.6Z" />
    </svg>
  );
}

export function PeopleIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <circle cx="9" cy="8" r="3" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <circle cx="17" cy="9" r="2.3" />
      <path d="M15.3 13.2a5 5 0 0 1 6.2 4.8" />
    </svg>
  );
}

export function PayrollIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <rect x="3.5" y="4" width="12" height="16" rx="1.4" />
      <path d="M7 8.3h5M7 11.6h5M7 14.9h3" />
      <circle cx="17.5" cy="16.5" r="3.2" />
      <path d="M17.5 15v3M16 16.5h3" />
    </svg>
  );
}

export function ReportIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <path d="M6 3.5h8l4 4V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z" />
      <path d="M14 3.5V7.5h4" />
      <path d="M8 12h8M8 15.5h8M8 8.5h3" />
    </svg>
  );
}

export function RiskIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <path d="M12 3.5 2.5 20h19L12 3.5Z" />
      <path d="M12 10v4.2" />
      <circle cx="12" cy="17" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function SaveIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <path d="M4.5 13a5.5 5.5 0 0 1 5.5-5.5h3.6c1 0 1.9.4 2.6 1.1l1.3-1.3 1 .4-.3 1.7c.5.7.8 1.6.8 2.6v1a2 2 0 0 1-2 2h-.5l-.6 2h-2l-.3-1.6H9.8L9.5 18h-2l-.5-2.3A4.5 4.5 0 0 1 4.5 13Z" />
      <circle cx="9" cy="12" r="0.8" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function ReleaseIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <rect x="5" y="11" width="14" height="9" rx="1.5" />
      <path d="M8 11V7a4 4 0 0 1 7.4-2.1" />
      <circle cx="12" cy="15.2" r="1.3" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function GrowIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <path d="M12 21V10" />
      <path d="M12 10c0-4 3-6 6-6 0 4-2 6-6 6Z" />
      <path d="M12 14c0-3-2.5-4.5-5-4.5 0 3 2 4.5 5 4.5Z" />
    </svg>
  );
}

export function ProtectIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <path d="M12 3 4.5 5.6v5.7c0 5 3.1 8.2 7.5 9.6 4.4-1.4 7.5-4.6 7.5-9.6V5.6L12 3Z" />
      <path d="M8.7 12.1l2.2 2.2 4.4-4.5" />
    </svg>
  );
}

export function PlayIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base}>
      <circle cx="12" cy="12" r="9" />
      <path d="M10 8.3l6 3.7-6 3.7V8.3Z" fill="currentColor" stroke="none" />
    </svg>
  );
}
